module.exports = __webpack_public_path__ + "media/monsterMagic1.5a65ec33.wav";